import { Component, Input, OnInit } from '@angular/core';
import { Observable, Subject, catchError, debounceTime, distinctUntilChanged, of, switchMap, tap } from 'rxjs';
import { ProductCollectionService } from 'src/app/services/product-collection.service';
import { ToastrService } from 'ngx-toastr';
import { ProductCollectionField } from 'src/app/interfaces/product-collections';

@Component({
  selector: 'app-lookup-products-collection-brands-dropdown',
  templateUrl: './brands-dropdown.component.html',
  styleUrls: ['./brands-dropdown.component.scss']
})
export class LookupProductsCollectionBrandsDropdownComponent implements OnInit {
  @Input() field!: ProductCollectionField;

  brands!: Observable<string[]>;
  searching: boolean = false;
  selectedBrands: string[] = [];
  searchSubject = new Subject<string>();

  constructor(
    private productCollectionService: ProductCollectionService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.brands = this.searchSubject.pipe(
      distinctUntilChanged(),
      debounceTime(300),
      tap(() => this.searching = true),
      switchMap(searchString => {
        if (searchString && searchString.trim() !== '') {
          return this.productCollectionService.getBrands(searchString, 20).pipe(
            tap(() => this.searching = false),
            catchError(error => {
              console.error('Brand Search Error:', error);
              this.toastr.error('Something went wrong with searching brands, try searching again.');
              return of([]);
            })
          );
        } else {
          return of([]).pipe(
            tap(() => this.searching = false)
          );
        }
      })
    );
  }

  onBrandSelect() {
    this.field.value = [...this.selectedBrands].join(',');
  }
}
